export const columnContactList = [
  {
    key: "profile_name",
    label: "Profile Name",
    filter: false,
    sorter: true
  },
  {
    key: "company_name",
    label: "Company Name",
    filter: false,
    sorter: false
  },
  {
    key: "wa_id",
    label: "Phone Number",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Register Date",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]